import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

export const useIsMobileShellEnabled = () => {
  const isMobile = useIsMobile();

  const isMobileShellEnabled = useIsCircleV4FeatureEnabled(
    "circle_v4_mobileshell_enabled",
    { requireAdminArea: false },
  );

  return isMobile && isMobileShellEnabled;
};
